import { Pipe, PipeTransform } from '@angular/core';

import {
    SelectedMetricMenu,
    SelectedMetricsMap,
} from '../components/metric-by-category-list/metric-by-category-list.interface';

/**
 * Check whether a submenu contains selected item(s)
 *
 * value: A composite object of booleans organized by category, section, menu, and metric ids, marking which metrics
 *   have been selected.
 *
 * Params:
 *   categoryLabel: The label of a metric category; this is the broadest way metrics are grouped.
 *   sectionLabel: The label of a metric section; this is part of a category and can contain individual metrics or
 *     submenus of individual metrics.
 *   menuLabel: The label of a metric menu, if the metric is part of a submenu; not all metrics are part of submenus.
 *
 */
@Pipe({
    name: 'isSubmenuItemSelected',
    standalone: false,
})
export class IsSubmenuItemSelected implements PipeTransform {
    transform(value: SelectedMetricsMap, categoryLabel: string, sectionLabel: string, menuLabel: string): boolean {
        return Object.values((value[categoryLabel][sectionLabel] as SelectedMetricMenu)[menuLabel]).some(
            (sublistItemSelected: boolean) => {
                return sublistItemSelected;
            }
        );
    }
}
